export default [
  {
    name: 'label.cs',
    label: {
      cs: 'Popisek [CS]',
      en: 'Label [CS]',
    },
    main: true,
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'label.en',
    label: {
      cs: 'Popisek [EN]',
      en: 'Label [EN]',
    },
    main: true,
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'code',
    label: {
      cs: 'Kód',
      en: 'Code',
    },
    input: 'input',
    note: '/img/partner/{code}',
    link: './#/admin/upload/image',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'type',
    label: {
      cs: 'Typ',
      en: 'Type',
    },
    input: 'select-menu',
    elements: [
      { value: 'general', label: 'General' },
      { value: 'main', label: 'Main' },
      { value: 'media', label: 'Media' },
      { value: 'municipality', label: 'Municipality' },
      { value: 'normal', label: 'Normal' },
    ],
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'link',
    label: {
      cs: 'Odkaz',
      en: 'Link',
    },
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 128,
    required: true,
  },
];
